import React, { Fragment, useState, useEffect, useContext } from 'react';
import UserPanel from './userPanel';
import SidebarFooter from './sidebarFooter.js';
import { getMenuList } from './menu';
import { AuthContext } from '../../../context/authContext/AuthContext';
import { Link } from 'react-router-dom';

const Sidebar = (props) => {
  const [margin, setMargin] = useState(0);
  const [width, setWidth] = useState(0);
  const [hideRightArrow, setHideRightArrow] = useState(true);
  const [hideLeftArrow, setHideLeftArrow] = useState(true);
  const { user } = useContext(AuthContext);

  var currentMenuItems = getMenuList(user?.role);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    handleResize();

    var currentUrl = window.location.pathname;

    currentMenuItems.filter((items) => {
      if (items.path === currentUrl) setNavActive(items);
      if (!items.children) return false;
      items.children.filter((subItems) => {
        if (subItems.path === currentUrl) setNavActive(subItems);
        if (!subItems.children) return false;
        subItems.children.filter((subSubItems) => {
          if (subSubItems.path === currentUrl) {
            setNavActive(subSubItems);
            return true;
          } else {
            return false;
          }
        });
        return subItems;
      });
      return items;
    });

    const timeout = setTimeout(() => {
      const elmnt = document.getElementById('myDIV');
      const menuWidth = elmnt.offsetWidth;
      if (menuWidth > window.innerWidth) {
        setHideRightArrow(false);
      } else {
        setHideRightArrow(true);
      }
    }, 500);

    return () => {
      window.removeEventListener('resize', handleResize);
      clearTimeout(timeout);
    };
  }, []);

  const handleResize = () => {
    setWidth(window.innerWidth - 310);
  };

  const setNavActive = (item) => {
    currentMenuItems.filter((menuItem) => {
      if (menuItem !== item) menuItem.active = false;
      if (menuItem.children && menuItem.children.includes(item)) menuItem.active = true;
      if (menuItem.children) {
        menuItem.children.filter((submenuItems) => {
          if (submenuItems.children && submenuItems.children.includes(item)) {
            menuItem.active = true;
            submenuItems.active = true;
            return true;
          } else {
            return false;
          }
        });
      }
      return menuItem;
    });
    item.active = !item.active;
  };

  // Click Toggle menu
  const toggletNavActive = (item) => {
    if (!item.active) {
      currentMenuItems.forEach((a) => {
        if (currentMenuItems.includes(item)) a.active = false;
        if (!a.children) return false;
        a.children.forEach((b) => {
          if (a.children.includes(item)) {
            b.active = false;
          }
          if (!b.children) return false;
          b.children.forEach((c) => {
            if (b.children.includes(item)) {
              c.active = false;
            }
          });
        });
      });
    }
    item.active = !item.active;
  };

  const scrollToRight = () => {
    const elmnt = document.getElementById('myDIV');
    const menuWidth = elmnt.offsetWidth;
    const temp = menuWidth + margin;
    if (temp < menuWidth) {
      setMargin(-temp);
      setHideRightArrow(true);
    } else {
      setMargin((margin) => (margin += -width));
      setHideLeftArrow(false);
    }
  };

  const scrollToLeft = () => {
    // If Margin is reach between screen resolution
    if (margin >= -width) {
      setMargin(0);
      setHideLeftArrow(true);
    } else {
      setMargin((margin) => (margin += width));
      setHideRightArrow(false);
    }
  };

  return (
    <Fragment>
      <div className="page-sidebar d-flex flex-column justify-content-between" sidebar-layout="iconcolor-sidebar">
        <div className="sidebar custom-scrollbar">
          <UserPanel />
          <ul className="sidebar-menu" id="myDIV" style={{ margin: '0px', padding: '0 20px', marginBottom: '2rem' }}>
            <li className={`left-arrow ${hideLeftArrow ? 'd-none' : ''}`} onClick={scrollToLeft}>
              <i className="fa fa-angle-left"></i>
            </li>
            {currentMenuItems.map((menuItem, i) => (
              <li className={`${menuItem.active ? 'active' : ''}`} key={i}>
                {menuItem.type === 'divider' ? (
                  <hr style={{ margin: '1rem 0', color: '#D4E1E7', border: '2px solid' }} />
                ) : menuItem.type === 'heading' ? (
                  <div style={{ fontWeight: 'bold', color: '#D4E1E7', margin: '1rem 0' }}>{menuItem.title}</div>
                ) : (
                  <>
                    {menuItem.sidebartitle ? <div className="sidebar-title">{menuItem.sidebartitle}</div> : null}
                    {menuItem.type === 'sub' ? (
                      <a className="sidebar-header" href="#javascript" onClick={() => toggletNavActive(menuItem)}>
                        <menuItem.icon />
                        <span>{menuItem.title}</span>
                        <i className="fa fa-angle-right pull-right"></i>
                      </a>
                    ) : null}
                    {menuItem.type === 'link' ? (
                      <Link
                        to={`${process.env.PUBLIC_URL}${menuItem.path}`}
                        className={`sidebar-header ${menuItem.active ? 'active' : ''}`}
                        onClick={() => toggletNavActive(menuItem)}
                      >
                        <menuItem.icon />
                        <span>{menuItem.title}</span>
                        {menuItem.children ? <i className="fa fa-angle-right pull-right"></i> : null}
                      </Link>
                    ) : null}
                    {menuItem.children ? (
                      <ul
                        className={`sidebar-submenu ${menuItem.active ? 'menu-open' : ''}`}
                        style={menuItem.active ? { opacity: 1, transition: 'opacity 500ms ease-in' } : {}}
                      >
                        {menuItem.children.map((childrenItem, index) => (
                          <li key={index} className={childrenItem.active ? 'active' : ''}>
                            {childrenItem.type === 'link' ? (
                              <Link
                                to={`${process.env.PUBLIC_URL}${childrenItem.path}`}
                                className={childrenItem.active ? 'active' : ''}
                                onClick={() => toggletNavActive(childrenItem)}
                              >
                                <i className="fa fa-circle"></i>
                                {childrenItem.title}
                              </Link>
                            ) : (
                              ''
                            )}
                            {childrenItem.type === 'sub' ? (
                              <a href="#javascript" onClick={() => toggletNavActive(childrenItem)}>
                                <i className="fa fa-circle"></i>
                                {childrenItem.title}
                                <i className="fa fa-angle-right pull-right"></i>
                              </a>
                            ) : null}
                          </li>
                        ))}
                      </ul>
                    ) : null}
                  </>
                )}
              </li>
            ))}
            <li className={`right-arrow ${hideRightArrow ? 'd-none' : ''}`} onClick={scrollToRight}>
              <i className="fa fa-angle-right"></i>
            </li>
          </ul>
        </div>
        {/* <SidebarFooter /> */}
      </div>
    </Fragment>
  );
};

export default Sidebar;
